import { render } from "./DishCard.vue?vue&type=template&id=5026d49e&lang=pug"
import script from "./DishCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DishCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__